import React from 'react';

import Stars from '../../../components/Badge/Stars';
import StatusCell from '../../../components/Badge/StatusCell';
import Table from '../../../components/Table/Table';
import TableDateFormatter from '../../../components/Table/TableAccessories/TableDateFormatter';

const ReportList = () => {
  return (
    <Table
      tableTitle='CONFLICT DETAILS'
      tableHeader={{
        Date: 'date',
        'Report Type': 'reportType',
        'Severity Rating': 'severityRating',
      }}
      tableDataSourceUrl='authentication-service/ba/v1/company/users/warehouse'
      cellsCustomComp={{
        date: <TableDateFormatter dataKey='date' />,
        reportType: <StatusCell statusKey='reportType' />,
        severityRating: <Stars dataKey='severityRating' />,
      }}
      // mobileCellComp={<UserProfileManagementCell />}
      // showPaginationControl={false}
    />
  );
};

export default ReportList;
